<template>
  <div>
    <audio-player ref="audioPlayer"></audio-player>
  </div>
  <!-- Get Emeralds Modal -->
  <transition name="fade">
    <div v-if="showGetEmeraldsModal" class="shop-scrim" :class="{ 'shop-raised': raised }" @click="handleCloseFromShop"></div>
  </transition>
  <transition name="fade">
    <div v-if="showGetEmeraldsModal" class="modal menu-modal" :class="{ 'shop-raised': raised }">
      <div class="modal-content">
        <div class="x-modal-header">
          <close-icon :on-click="handleCloseFromShop" />
        </div>

        <!-- If we're in Checkout mode -->
        <div v-if="checkoutStatus === 'checkout'">
          <div v-if="showStripeCardElement">
            <div id="payment-element"><!-- Mount the Payment Element here --></div>
            <div class="payment-button-container">
              <button class="standard-button" @click="submitPayment" :disabled="store.is_loading">
                Submit Payment
              </button>
            </div>
          </div>
        </div>

        <!-- Main Content -->
        <div v-if="checkoutStatus === ''">
          <div class="products-columns">
            <!-- Left Column: Non-Subscription Products -->
            <div class="products-container" v-if="showShopSection">
              <div class="hero">
                <h2>Emeralds</h2>
                <p class="hero-subtext">Pay Per Reading</p>
              </div>
              <div
                v-for="product in otherProducts"
                :key="product.stripe_product_id"
                class="product-card"
              >
                <div class="product-card-columns">
                  <div class="product-image-container">
                    <img :src="product.image" alt="" class="product-image" />
                  </div>
                  <div class="product-info">
                    <h3 class="product-name">{{ product.name }}</h3>
                    <!-- Carats spelled out. The pack name carries the number
                         bare ("Sack of 500") and the tag line talks Emeralds,
                         so the unit you actually spend was never named. -->
                    <p v-if="product.carats_granted" class="product-carats">
                      {{ Number(product.carats_granted).toLocaleString() }} carats
                    </p>
                    <p class="tag_line">{{ product.tag_line }}</p>
                    <div class="price-info">
                      <span class="price">${{ product.default_prices[0].price }}</span>
                      <button
                        @click="handleBuyButtonClick(product.default_prices[0].stripe_price_id)"
                        class="standard-button buy-button"
                      >
                        Buy
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <p v-if="!otherProducts.length" class="products-empty">
                {{ emptyMessage }}
              </p>
            </div>

            <!-- Right Column: Subscription Products -->
            <!-- Subscriptions are retired. The section is driven by what the
                 catalog returns, so it reappears on its own if they are put
                 back on sale — no code change to undo. -->
            <div
              class="products-container"
              v-if="showShopSection && !querent_subscribed && subscriptionProducts.length"
            >
              <div class="hero">
                <h2>Subscription</h2>
                <p class="hero-subtext">Unlimited Readings</p>
              </div>
              <div
                v-for="product in subscriptionProducts"
                :key="product.stripe_product_id"
                class="product-card"
              >
                <div class="product-card-columns">
                  <div class="product-image-container">
                    <img :src="product.image" alt="" class="product-image" />
                  </div>
                  <div class="product-info">
                    <h3 class="product-name">{{ product.name }}</h3>
                    <p class="tag_line">
                      {{ product.tag_line }}
                      <i class="fas fa-gem" title="Extra carats"></i>
                    </p>
                    <div class="price-info">
                      <span class="price">${{ product.default_prices[0].price }}</span>
                      <button
                        @click="handleBuyButtonClick(product.default_prices[0].stripe_price_id)"
                        class="standard-button buy-button"
                      >
                        Subscribe
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <p v-if="!subscriptionProducts.length" class="products-empty">
                {{ emptyMessage }}
              </p>
            </div>


            <!-- Quest Fulfilled Column -->
            <div class="products-container" v-if="showQuestSection">
              <div class="hero">
                <h2>Fulfilled Quest</h2>
                <p class="hero-subtext">Collect your carats</p>
              </div>
              <!-- Countdown Timer as a Product Card (ONLY SHOWS if remainingTime exists) -->
              <div v-if="remainingTime" class="product-card countdown-product-card">
                <div class="product-card-columns">
                  <div class="product-image-container">
                    <!-- Use any image you'd like here -->
                    <img
                      :src="nextDailyRewardImage"
                      alt="Countdown Icon"
                      class="product-image"
                    />
                  </div>
                  <div class="product-info">
                    <h3><b class="product-name">Daily Reward <br>Countdown</b></h3>
                    <p class="tag_line">Next reward available in:</p>
                    <div class="price-info">
                      <p class="price timer">
                        {{ remainingTime.hours }}h {{ remainingTime.minutes }}m {{ remainingTime.seconds }}s
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Quests to Claim -->
              <div v-for="product in questToClaim" :key="product.id" class="product-card">
                <div class="product-card-columns">
                  <div class="product-image-container">
                    <img :src="product.image" alt="Product Image" class="product-image" />
                  </div>
                  <div class="product-info">
                    <h3><b class="product-name">{{ product.name }}</b></h3>
                    <p class="tag_line">{{ product.description }} for visiting on {{ product.date_inserted }}</p>
                    <div class="price-info">
                      <p class="price">
                        <button
                          @click="selectCollectReward(product.id)"
                          class="standard-button buy-button"
                        >
                          Collect {{ product.payout_carats }}
                          <i class="fas fa-gem"></i>
                        </button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>



          </div>
        </div>

        <!-- Success -->
        <div v-else-if="checkoutStatus === 'success'" class="hero">
          <h1>Thank you for your purchase!</h1>
          <p class="hero-subtext" v-if="querent_subscribed">
            Your access to endless readings lasts until {{ formattedSubscriptionExpiration }}.
          </p>
          <p class="hero-subtext">
            You've acquired {{ emeraldsPurchased }} carats.
            <i class="fas fa-gem" title="Extra carats"></i>
          </p>
          <button @click="hide_all_modals">Reveal Your Next Insight</button>
        </div>

        <!-- Cancel -->
        <div v-else-if="checkoutStatus === 'cancel'">
          <p>Forgot to add something to your cart? Shop around then come back to pay!</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { format } from 'date-fns';
import axios from "@/axiosConfig";
import CloseIcon from '@/components/ui/CloseIcon.vue';
import { static_store } from '@/store';
import AudioPlayer from '@/components/ui/AudioPlayer.vue';
import {getCookie} from "@/utils/general-utils";
import { track } from '@/utils/analytics';

export default {
  emits: [
    'hideAllModals',
    'updateLoadingStatus',
    'updateQuerentSubscribed',
    'updateQuerentSubscriptionExpiration',
    'updateQuerentCaratBalance',
    'updateActiveTab',
  ],
  components: { CloseIcon, AudioPlayer },
  props: {
    showGetEmeraldsModal: Boolean,
    // Opened from a screen that sits above the page (the gift send, 1200):
    // the store comes up over it, so that screen and its words stay as they were.
    raised: { type: Boolean, default: false },
    store: Object,
    querent_subscribed: Boolean,
    mode: {
      type: String,
      default: 'all',  // 'all' | 'shop' | 'quest'
      validator: v => ['all', 'shop', 'quest'].includes(v),
    },
  },
  data() {
    return {
      emeraldAudioPlayer: null,
      stripe: null,
      client_secret: null,
      purchase_intent_id: null,
      // What is in the cart, for begin_checkout / purchase (analytics).
      checkoutItem: null,
      elements: null,
      payment_element: null,
      static_store,
      showStripeCardElement: false,
      checkoutStatus: '',
      readerProducts: [],
      // 'idle' until the first fetch resolves, so an empty list before it lands
      // is not reported as a shop with nothing in it.
      productsStatus: 'idle',
      readerQuest: [],
      questToClaim: [],
      emeraldsPurchased: 0,

      // Countdown data
      nextDailyReward: null,
      nextDailyRewardImage: null,
      remainingTime: null,
      timerInterval: null,
    };
  },
  mounted() {
    // Keep your audio reference
    this.emeraldAudioPlayer = this.$refs.audioPlayer;
    // The products are fetched by the watchers below (immediate).
  },
  watch: {
    showGetEmeraldsModal(newValue) {
      if (newValue === true) {
        // Fresh when the shop is opened (balance, quests to claim).
        if (this.store.querent_id) this.fetchReaderProducts();
        this.showStripeCardElement = true;
        this.initializeStripe();
      } else {
        // Stop the countdown if modal is closed
        this.stopCountdown();
      }
      this.checkoutStatus = '';
    },
    // Who is signed in, on which session: the products are asked again only
    // when one of those changes. A deep watch on the whole store asked on
    // every change anywhere (a dozen times per gift-room load; gift bug walk
    // 2026-10-25 #38).
    'store.querent_id': {
      handler(id) { if (id) this.fetchReaderProducts(); },
      immediate: true,
    },
    'store.session_id'(sid) {
      if (sid && this.store.querent_id) this.fetchReaderProducts();
    },
    'store.querent_carat_balance'() {
      if (this.store.querent_id) this.fetchReaderProducts();
    }
  },
  computed: {
    formattedSubscriptionExpiration() {
      const expiration = this.store.querent_subscription_expiration;
      if (!expiration) {
        console.warn('querent_subscription_expiration is undefined or null');
        return 'N/A';
      }
      const subscriptionExpiration = new Date(expiration);
      if (isNaN(subscriptionExpiration.getTime())) {
        console.warn('Invalid date value for querent_subscription_expiration:', expiration);
        return 'Invalid date';
      }
      return format(subscriptionExpiration, 'MM-dd-yyyy');
    },
    showShopSection() {
      return this.mode === 'all' || this.mode === 'shop';
    },
    showQuestSection() {
      return this.mode === 'all' || this.mode === 'quest';
    },
    subscriptionProducts() {
      return this.readerProducts.filter(
        (product) => product.product_category === 'Subscription'
      );
    },
    otherProducts() {
      // Filter any product that's not subscription
      return this.readerProducts.filter(
        (product) => product.product_category !== 'Subscription'
      );
    },
    emptyMessage() {
      // The shop used to render its headers over an empty list and say
      // nothing, so a failed fetch was indistinguishable from a working shop.
      if (this.productsStatus === 'error') return 'Could not load the shop. Try again in a moment.';
      if (this.productsStatus === 'loaded') return 'Nothing available right now.';
      return 'Loading...';
    },
    isPlayingEmeraldSound() {
      return (
        this.emeraldAudioPlayer &&
        !this.emeraldAudioPlayer.paused &&
        !this.emeraldAudioPlayer.ended &&
        this.emeraldAudioPlayer.currentTime > 0
      );
    },
  },
  methods: {
    handleCloseFromShop() {
      this.$emit('hideAllModals', true);
      this.$emit('updateActiveTab', 'coach');
    },

    hide_all_modals(val) {
      this.$emit('hideAllModals', val);
    },
    async initializeStripe() {
      if (this.stripe) return;
      try {
        const Stripe = await this.loadStripe();
        this.stripe = Stripe(this.static_store.stripe_public_key);
      } catch (error) {
        console.error('Error loading Stripe:', error);
      }
    },
    async loadStripe() {
      if (window.Stripe) {
        return window.Stripe;
      }
      return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/';
        script.onload = () => resolve(window.Stripe);
        document.head.appendChild(script);
      });
    },
    currentSessionId() {
      // start-session writes the session to the store, localStorage AND the
      // cookie. Reading only the cookie meant that if it was missing or
      // unreadable the shop posted session_id: undefined, took a 400, and
      // rendered as though the catalog were empty.
      return this.store?.session_id
        || localStorage.getItem('session_id')
        || getCookie('session_id')
        || null;
    },
    async fetchReaderProducts() {
      const session_id = this.currentSessionId();
      if (!session_id) {
        // Nothing to ask with yet; the store watcher calls again once
        // start-session lands. Not an error state.
        return;
      }
      try {
        const response = await axios.post(
          `${this.static_store.apiUrl}/reading/get-emeralds/`,
          { session_id }
        );
        this.readerProducts = response.data.products || [];
        this.productsStatus = 'loaded';
        this.readerQuest = response.data.quests;
        this.questToClaim = response.data.redeemable_querent_quests;

        // Capture daily reward
        const dailyPkg = response.data.daily_rewards_package || null;
        this.nextDailyReward = dailyPkg?.next_daily_reward ?? null;

        if (this.nextDailyReward) {
          this.startCountdown();
        }
        this.nextDailyRewardImage = dailyPkg?.image_url ?? null;

      } catch (error) {
        this.productsStatus = 'error';
        console.error('Error fetching reader products:', error);
      }
    },
    // Countdown Timer
    startCountdown() {
      const targetTime = new Date(this.nextDailyReward).getTime();
      if (this.timerInterval) clearInterval(this.timerInterval);

      this.timerInterval = setInterval(() => {
        const currentTime = Date.now();
        const timeLeft = targetTime - currentTime;

        if (timeLeft <= 0) {
          clearInterval(this.timerInterval);
          this.remainingTime = null;
        } else {
          this.remainingTime = {
            hours: Math.floor(timeLeft / (1000 * 60 * 60)),
            minutes: Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)),
            seconds: Math.floor((timeLeft % (1000 * 60)) / 1000),
          };
        }
      }, 1000);
    },
    stopCountdown() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },

    // Collect a Reward
    async selectCollectReward(reward_id) {
      try {
        const response = await axios.post(
          `${this.static_store.apiUrl}/reading/collect-reward/`,
          {
            session_id: localStorage.getItem('session_id'),
            reward_id,
          }
        );

        if(response.data.added_carats){
          this.animateEmeraldsCount(response.data.old_carat_balance, response.data.new_emerald_balance)
          this.questToClaim = response.data.redeemable_querent_quests;
          }
      } catch (error) {
        console.error('Error fetching reader products:', error);
      }
    },

    // The product behind a Stripe price, as a GA4 item.
    analyticsItem(stripe_price_id) {
      const product = (this.readerProducts || []).find((p) =>
        (p.default_prices || []).some((pr) => pr.stripe_price_id === stripe_price_id)) || {};
      const price = (product.default_prices || []).find((pr) => pr.stripe_price_id === stripe_price_id) || {};
      return {
        item_id: product.stripe_product_id || stripe_price_id,
        item_name: product.name || 'carats',
        item_category: product.product_category || '',
        price: Number(price.price) || 0,
        quantity: 1,
        carats: Number(product.carats_granted) || undefined,
      };
    },

    // Stripe Payment
    async handleBuyButtonClick(stripe_price_id) {
      try {
        const data = { stripe_price_id, querent_id: this.store.querent_id };
        const response = await axios.post(
          `${this.static_store.apiUrl}/stripe-create-payment-intent/`,
          data
        );
        const client_secret = response.data.clientSecret;
        this.showStripeCardElement = true;
        this.checkoutStatus = 'checkout';

        this.client_secret = client_secret;
        this.purchase_intent_id = response.data.purchase_intent_id;
        this.checkoutItem = this.analyticsItem(stripe_price_id);
        track('begin_checkout', {
          currency: 'USD', value: this.checkoutItem.price, items: [this.checkoutItem],
        });

        const appearance = { theme: 'stripe' };
        const Stripe = await this.loadStripe();
        this.stripe = Stripe(this.static_store.stripe_public_key);

        const elements = this.stripe.elements({
          clientSecret: client_secret,
          appearance,
        });
        const paymentElement = elements.create('payment');
        paymentElement.mount('#payment-element');

        this.elements = elements;
        this.payment_element = paymentElement;
      } catch (error) {
        console.error('Error creating payment intent:', error);
      }
    },
    async submitPayment() {
      this.$emit('updateLoadingStatus', true); // Notify parent to update loading status
      this.$emit('updateCheckoutStatus', 'checkout');
      const client_secret = this.client_secret;
      const elements = this.elements;

      try {
        const submissionResult = await elements.submit();
        if (submissionResult.error) {
          alert(submissionResult.error.message);
          return;
        }

        const { error } = await this.stripe.confirmPayment({
          elements,
          clientSecret: client_secret,
          confirmParams: {
            return_url: `${this.static_store.apiUrl}/stripe-payment-success/`,
          },
          redirect: 'if_required',
        });
        if (error) {
          this.checkoutStatus = 'cancel';
        } else {
          this.checkoutStatus = 'success';
          let url_address = `${this.static_store.apiUrl}/stripe-payment-success/?`;
          url_address += `querent_purchase_intent_id=${encodeURIComponent(this.purchase_intent_id)}`;
          url_address += `&client_secret=${encodeURIComponent(client_secret)}`;

          const response = await axios.get(url_address);
          const previousEmeraldBalance = this.store.querent_carat_balance;
          const newEmeraldBalance = response.data.carat_balance;
          this.emeraldsPurchased = newEmeraldBalance - previousEmeraldBalance;
          const item = this.checkoutItem || {};
          track('purchase', {
            transaction_id: String(this.purchase_intent_id || ''),
            currency: 'USD', value: item.price, items: item.item_id ? [item] : undefined,
          });

          this.animateEmeraldsCount(previousEmeraldBalance, newEmeraldBalance);

          // Emit events to request the parent to update the state
          this.$emit('updateQuerentSubscribed', response.data.querent_subscribed);
          this.$emit('updateQuerentSubscriptionExpiration', response.data.querent_subscription_expiration);
        }
      } catch (error) {
        console.error('Error during the payment process:', error);
        alert('An error occurred during the payment process.');
      } finally {
        this.$emit('updateLoadingStatus', false); // Notify parent to update loading status
      }
    },

    // Emerald Animation
    animateEmeraldsCount(oldBalance, newBalance) {
      let startValue = oldBalance;
      const endValue = newBalance;
      const incrementAmount = endValue - startValue;
      const baseDuration = 1000;
      const maxDuration = 15000;
      const minDuration = 5000;

      let duration = Math.max(
        minDuration,
        Math.min(maxDuration, baseDuration - incrementAmount * 10)
      );

      let stepTime = 50;
      let steps = duration / stepTime;
      let increment = incrementAmount / steps;
      let interval = setInterval(() => {
        this.$refs.audioPlayer.playEmeraldSound();
        this.$emit('updateQuerentCaratBalance', Math.round(startValue));
        startValue += increment;
        if (startValue >= endValue) {
          clearInterval(interval);
          this.$emit('updateQuerentCaratBalance', endValue);
        }
      }, stepTime);
    },
  },
  beforeUnmount() {
    // Ensure we stop any countdown intervals
    this.stopCountdown();
  },
};
</script>

<style scoped>

/*
 * Dressed in the app's own modal language rather than the browser defaults it
 * shipped with. Tokens are BirthDetailsModal's, which is the established
 * treatment: #14071f panel, gold hairline border, Cinzel titles in #f5e8c0,
 * #9b86c9 for supporting copy, and the violet pill for the primary action.
 */
.shop-scrim {
  position: fixed;
  inset: 0;
  z-index: 1099; /* directly beneath .menu-modal's 1100 */
  background: rgba(6, 0, 14, 0.82);
  backdrop-filter: blur(3px);
}
/* Over the gift send (1200): "Get carats" there opens the store on top. */
.shop-raised.shop-scrim { z-index: 1290; }
.shop-raised.menu-modal { z-index: 1300; }
.modal {
  height: auto;
  max-height: 88vh;
  width: 90%;
  max-width: 1024px;
  overflow-y: hidden;
  background: transparent;
}
/* The shared sheet paints .modal-content white at phone widths; this scoped
   rule carries the [data-v] attribute, so it outranks it. */
.modal-content {
  background: #14071f;
  border: 1px solid rgba(240, 217, 163, 0.22);
  border-radius: 18px;
  box-shadow: 0 26px 60px -16px rgba(0, 0, 0, 0.85);
  color: #e9dcff;
  padding: 18px 16px 20px;
}
/* auto-fit rather than a fixed pair: with subscriptions retired a hard 1fr 1fr
   left the one remaining section stranded at half width on desktop. */
.products-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 14px;
  width: 100%;
}
.products-container {
  width: 100%;
  margin: 0;
}
.products-empty {
  margin: 0;
  padding: 22px 12px;
  text-align: center;
  color: #9b86c9;
  font-size: 13px;
}
.product-card {
  width: 100%;
  border: 1px solid rgba(155, 134, 201, 0.22);
  background: rgba(255, 255, 255, 0.035);
  padding: 12px;
  margin: 0 0 10px;
  border-radius: 14px;
  box-sizing: border-box;
  transition: border-color 0.2s ease, background 0.2s ease;
}
.product-card:hover {
  border-color: rgba(240, 217, 163, 0.4);
  background: rgba(255, 255, 255, 0.06);
}
.product-card-columns {
  display: flex;
  align-items: center;
  gap: 14px;
}
/* The pack artwork is drawn on white, so it sits on a deliberate light tile
   with a gold hairline rather than reading as a stray white square. */
.product-image-container {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 12px;
  background: #f7f2ea;
  border: 1px solid rgba(240, 217, 163, 0.35);
}
.product-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
/* The shared sheet centres everything inside .modal-content, which is right
   for the hero and wrong for a list of products. */
.product-info {
  flex: 1;
  min-width: 0;
  padding: 0;
  text-align: left;
}
.product-name {
  font-family: 'Cinzel', serif;
  font-size: 15px;
  font-weight: 600;
  color: #f5e8c0;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.product-carats {
  margin: 2px 0 0;
  font-family: 'Cinzel', serif; font-size: 15px; font-weight: 600;
  color: #f0d9a3;
}
.tag_line {
  margin: 3px 0 0;
  font-size: 12px;
  color: #9b86c9;
}
/* Price and action on one line — the old markup read "Buy for $4.99" with the
   button mid-sentence, so "for" orphaned onto the button's line. */
.price-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
}
.price {
  color: #e9dcff;
  font-size: 15px;
  font-weight: 700;
  margin: 0;
}
/* .modal .standard-button in the shared sheet is (0,2,0) and pins a 6px
   radius; the extra class here outranks it so the pill survives. */
.product-card .standard-button,
.product-card .buy-button,
.payment-button-container .standard-button {
  background: linear-gradient(180deg, #7b4bb0, #4e2776);
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 9px 22px;
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  font-family: inherit;
  line-height: 1.2;
  cursor: pointer;
  transition: filter 0.2s ease;
}
.product-card .standard-button:hover,
.product-card .buy-button:hover,
.payment-button-container .standard-button:hover {
  background: linear-gradient(180deg, #7b4bb0, #4e2776);
  filter: brightness(1.12);
}
.product-card .buy-button:focus-visible {
  outline: 2px solid #f0d9a3;
  outline-offset: 2px;
}
.hero {
  text-align: center;
  margin: 0 0 14px;
  background: transparent;
  padding: 0 0 12px;
  border-bottom: 1px solid rgba(155, 134, 201, 0.18);
  box-shadow: none;
  width: 100%;
}
.hero :deep(h2),
.hero h2 {
  font-family: 'Cinzel', serif;
  font-size: 18px;
  color: #f5e8c0;
  margin: 0;
}
.hero-subtext {
  font-size: 12.5px;
  color: #9b86c9;
  margin-top: 5px;
}
.fas.fa-gem {
  color: #50C878;
  margin-left: 6px;
}
/* The close control is a shared component drawn for a light sheet. */
.x-modal-header {
  border-bottom: none;
  padding: 0;
}
.x-modal-header :deep(svg) {
  color: #9b86c9;
  stroke: #9b86c9;
}
.x-modal-header :deep(svg:hover) {
  color: #f0d9a3;
  stroke: #f0d9a3;
}
.payment-button-container {
  margin-top: 10em;
  text-align: center;
}
.price {
  color: #555;
  margin: 0 0 10px 0;
}
.buy-button {
  background-color: #663399;
  color: white;
  padding: 8px 12px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9em;
  align-self: center;
}
.buy-button:hover {
  background-color: #0056b3;
}
/* Additional styling for countdown card */
.product-card.countdown-product-card .timer {
  font-weight: bold;
  font-size: 1em;
  color: #663399;
}
@media screen and (max-width: 768px) {
  .products-columns {
    grid-template-columns: 1fr;
    justify-items: center;
  }
  /* This scoped rule is (0,2,0) and outranks the shared .menu-modal phone
     block, so the height budget has to be restated here or the shop runs
     under the bottom nav. */
  .modal {
    top: 24px;
    max-height: calc(100vh - 120px);
    overflow-y: auto;
  }
  .modal-content {
    padding: 16px;
  }
}
</style>
